import React, { useCallback } from 'react';
import { MaterialIcons } from '@expo/vector-icons';
import { Pressable, StyleSheet, Text } from 'react-native';
import { useRouter } from 'expo-router';

import { reviewDesk } from '@/design-system';
import { useTranslation } from '@/hooks/useTranslation';
import { ROUTES } from '@/navigation/routes';

export function ProgressBackButton() {
  const router = useRouter();
  const { t } = useTranslation();

  // Always land on Progress, as the label says. The detail routes live outside
  // (tabs) under a root Slot whose initial route is (public), so
  // router.back() popped to "/" (or "/dashboard" on a direct load) instead.
  const goBack = useCallback(() => {
    router.replace(ROUTES.TABS_PROGRESS as never);
  }, [router]);

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={t('icfProgress.backToProgress')}
      onPress={goBack}
      style={({ pressed }) => [styles.button, pressed && styles.pressed]}
    >
      <MaterialIcons name="chevron-left" size={22} color={reviewDesk.accent} />
      <Text style={styles.label}>{t('icfProgress.backToProgress')}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    minHeight: 40,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    borderWidth: 1,
    borderColor: reviewDesk.line,
    borderRadius: 10,
    backgroundColor: reviewDesk.card,
    paddingLeft: 8,
    paddingRight: 12,
  },
  label: {
    color: reviewDesk.accent,
    fontSize: 14,
    fontWeight: '700',
  },
  pressed: { opacity: 0.68 },
});

export default ProgressBackButton;
